import { ThemeProps as Prop, ColorProfiles, Components } from '@powdr/constants';

export const woodwardTheme = {
  [ColorProfiles.BASE]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#000000',
    [Prop.LINK_TXT]: '#ffd200',
    [Prop.LINK_TXT_HOVER]: '#000000',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#b4b4b4',
    [Prop.BTN_TXT_INACTIVE]: '#FFFFFF',
    [Prop.BORDER]: '#000000',
    [Prop.ELEMENT]: '#e0e0e0',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.ICON]: '#ffd200',
    [Prop.ICON_HOVER]: '#000000',
  },
  [ColorProfiles.PRIMARY]: {
    [Prop.BACKGROUND]: '#ffd200',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#3B3937',
    [Prop.LINK_TXT]: '#ffffff',
    [Prop.LINK_TXT_HOVER]: '#000000',
    [Prop.BTN_BG]: '#000000',
    [Prop.BTN_TXT]: '#ffd200',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#ffffff',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#A29B6B',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.BORDER]: '#000000',
    [Prop.ELEMENT]: '#000000',
    [Prop.ELEMENT_TXT]: '#FFD200',
    [Prop.ICON]: '#000000',
    [Prop.ICON_HOVER]: '#ffffff',
  },
  [ColorProfiles.SECONDARY]: {
    [Prop.BACKGROUND]: '#000000',
    [Prop.HEADER]: '#ffd200',
    [Prop.CONTENT]: '#ffffff',
    [Prop.LINK_TXT]: '#ffd200',
    [Prop.LINK_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#3b3937',
    [Prop.BTN_BG_HOVER]: '#ffd200',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#ffffff',
    [Prop.BTN_TXT_ACTIVE]: '#000000',
    [Prop.BTN_BG_INACTIVE]: '#4d4d4d',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.BORDER]: '#ffd200',
    [Prop.ELEMENT]: '#4d4d4d',
    [Prop.ELEMENT_TXT]: '#e0e0e0',
    [Prop.ICON]: '#ffffff',
    [Prop.ICON_HOVER]: '#ffd200',
  },
  [ColorProfiles.TERTIARY]: {
    [Prop.BACKGROUND]: '#3a3a3a',
    [Prop.HEADER]: '#ffd200',
    [Prop.CONTENT]: '#ffffff',
    [Prop.LINK_TXT]: '#ffd200',
    [Prop.LINK_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#757575',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.BORDER]: '#ffffff',
    [Prop.ELEMENT]: '#696969',
    [Prop.ELEMENT_TXT]: '#e0e0e0',
    [Prop.ICON]: '#ffffff',
    [Prop.ICON_HOVER]: '#ffd200',
  },
  [ColorProfiles.QUATERNARY]: {
    [Prop.BACKGROUND]: '#f8f8f8',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#4a4a4a',
    [Prop.LINK_TXT]: '#000000',
    [Prop.LINK_TXT_HOVER]: '#ffd200',
    [Prop.BTN_BG]: '#000000',
    [Prop.BTN_TXT]: '#ffd200',
    [Prop.BTN_BG_HOVER]: '#ffd200',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#b4b4b4',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.BORDER]: '#ffd200',
    [Prop.ELEMENT]: '#b4b4b4',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.ICON]: '#ffd200',
    [Prop.ICON_HOVER]: '#000000',
  },
  [Components.DOR_LIFTS_TRAILS]: {
    [Prop.ICON_2]: '#ffd200',
    [Prop.ICON_HOVER_2]: '#000000',
    [Prop.HEADER_BG]: '#ffd200',
    [Prop.HEADER_TXT]: '#000000',
    [Prop.HEADER_ICON]: '#FFFFFF',
    [Prop.HEADER_BG_2]: '#000000',
    [Prop.HEADER_TXT_2]: '#ffd200',
    [Prop.HEADER_ICON_2]: '#FFFFFF',
    [Prop.TABLE_HEADER_BG]: '#b3b3b3',
    [Prop.TABLE_HEADER_TXT]: '#3F3F3F',
    [Prop.ODD_EVEN_OFFSET]: '#e0e0e0',
  },
};

export const componentThemesDefault = {
  [Components.DOR_LIFTS_TRAILS]: {
    [Prop.ICON_2]: '#b4b4b4',
    [Prop.ICON_HOVER_2]: '#b4b4b4',
    [Prop.HEADER_BG]: '#000000',
    [Prop.HEADER_TXT]: '#ffffff',
    [Prop.HEADER_ICON]: '#64CAC7',
    [Prop.HEADER_BG_2]: '#64CAC7',
    [Prop.HEADER_TXT_2]: '#ffffff',
    [Prop.HEADER_ICON_2]: '#ffffff',
    [Prop.TABLE_HEADER_BG]: '#b3b3b3',
    [Prop.TABLE_HEADER_TXT]: '#3F3F3F',
    [Prop.ODD_EVEN_OFFSET]: '#E5EDED',
  },

  // required for WW theme takeover
  [Components.ALERT_BAR]: {
    [Prop.BACKGROUND]: '#f8f8f8',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#4a4a4a',
    [Prop.LINK_TXT]: '#000000',
    [Prop.LINK_TXT_HOVER]: '#64CAC7',
    [Prop.BTN_BG]: '#000000',
    [Prop.BTN_TXT]: '#ffd200',
    [Prop.BTN_BG_HOVER]: '#ffd200',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.ICON]: '#64CAC7',
    [Prop.ICON_HOVER]: '#000000',
  },

  // required for WW theme takeover
  [Components.HEADER]: {
    [Prop.LOGO_BG]: '#FFD200',
    [Prop.NAV_BG]: '#000000',
    [Prop.NAV_ITEM_TXT_TRANSLUCENT]: '#FFFFFF',
    [Prop.NAV_ITEM_TXT_SOLID]: '#000000',
    [Prop.NAV_ITEM_TXT_ACTIVE]: '#000000',
    [Prop.NAV_ITEM_BG_ACTIVE]: '#FFFFFF',
    [Prop.NAV_ITEM_ACTIVE_ACCENT]: '#64CAC7',
    [Prop.WW_ICON_COLOR]: '#FFD200',
  },

  // required for WW theme takeover
  [Components.ECOMMERCE_BANNER]: {
    [Prop.BACKGROUND]: '#000000',
    [Prop.LINK_TXT]: '#64CAC7',
    [Prop.LINK_TXT_HOVER]: '#FFFFFF',
    [Prop.TOGGLE_ACTIVE]: '#C4C4BF',
    [Prop.TOGGLE_INACTIVE]: '#C4C4BF',
    [Prop.ELEMENT]: '#4D4D4D',
    [Prop.LINK_SEPARATOR]: '#5a5b5c',
  },

  // required for WW theme takeover
  [Components.WEATHER_FEED]: {
    [Prop.BACKGROUND]: '#000000',
    [Prop.ICON]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.DOR]: {
    [Prop.ICON]: '#64CAC7',
    [Prop.LINK_TXT]: '#64CAC7',
    [Prop.LINK_TXT_HOVER]: '#000000',
    [Prop.BORDER]: '#64CAC7',
    [Prop.COMPONENT_BORDER]: '#000000',
  },

  // required for WW theme takeover
  [Components.PROMOTIONS_FEED]: {
    [Prop.BACKGROUND]: '#FFD200',
    [Prop.LINK_TXT]: '#000000',
  },

  [Components.PROMOTIONS]: {
    [Prop.PROMO_ITEM_BG]: '#64CAC7',
    [Prop.PROMO_ITEM_HEADER]: '#000000',
    [Prop.PROMO_ITEM_CONTENT]: '#3B3937',
    [Prop.PROMO_ITEM_BTN_BG]: '#FFD200',
    [Prop.PROMO_ITEM_BTN_TXT]: '#000000',
    [Prop.PROMO_ITEM_BTN_BG_HOVER]: '#000000',
    [Prop.PROMO_ITEM_BTN_TXT_HOVER]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.MEGA_NAV]: {
    [Prop.LINK_TXT]: '#666666',
    [Prop.LINK_TXT_HOVER]: '#64CAC7',
    [Prop.BORDER]: '#000000',
  },

  // required for WW theme takeover
  [Components.MOBILE_NAV]: {
    [Prop.MENU_BTN_BG]: '#FFFFFF',
    [Prop.MENU_BTN_ICON]: '#64CAC7',
    [Prop.LOGO_BG]: '#FFFFFF',
    [Prop.CLOSE_BTN_BG]: '#FFD200',
    [Prop.CLOSE_BTN_ICON]: '#000000',
    [Prop.MAIN_NAV_BG]: '#FFFFFF',
    [Prop.MAIN_NAV_TXT]: '#666666',
    [Prop.MAIN_NAV_BORDER]: '#000000',
    [Prop.WW_ICON_COLOR]: '#FFD200',
    [Prop.DRAWER_BTN_BG]: '#FFFFFF',
    [Prop.DRAWER_BTN_TXT]: '#64CAC7',
    [Prop.PROMO_BTN_BG]: '#64CAC7',
    [Prop.PROMO_BTN_TXT]: '#000000',
    [Prop.SUB_NAV_BG]: '#FFD200',
    [Prop.SUB_NAV_TXT]: '#000000',
    [Prop.SUB_NAV_BORDER]: '#000000',
  },

  // required for WW theme takeover
  [Components.FOOTER]: {
    [Prop.BACKGROUND]: '#000000',
    [Prop.HEADER]: '#64CAC7',
    [Prop.BTN_BG]: '#FFD200',
    [Prop.BTN_TXT]: '#3b3937',
    [Prop.BTN_BG_HOVER]: '#FFD200',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.FOOTER_NAV]: {
    [Prop.LINK_TXT]: '#64CAC7',
    [Prop.LINK_TXT_HOVER]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.COPYRIGHT]: {
    [Prop.BACKGROUND]: '#64CAC7',
    [Prop.LINK_TXT]: '#FFFFFF',
  },

  [Components.FOOTER_CONTACT]: {
    [Prop.BACKGROUND]: '#FFD200',
    [Prop.CONTENT]: '#000000',
    [Prop.LINK_TXT]: '#000000',
    [Prop.LINK_TXT_HOVER]: '#ffffff',
  },
};
